module.exports = __webpack_public_path__ + "img/uploading.495e5bed.svg";